import React from 'react'
import './Footer.css'

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Báo Xã Việt Tiến</h3>
            <p>
              Báo điện tử - Thông tin chính thức và đáng tin cậy. Cập nhật tin tức mới nhất về chính trị, kinh tế, xã hội, văn hóa và thể thao.
            </p>
            <div className="social-links">
              <a href="#" aria-label="Facebook">📘</a>
              <a href="#" aria-label="Twitter">🐦</a>
              <a href="#" aria-label="YouTube">📺</a>
              <a href="#" aria-label="Zalo">💬</a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Chuyên mục</h4>
            <ul>
              <li><a href="#">Chính trị</a></li>
              <li><a href="#">Kinh tế</a></li>
              <li><a href="#">Xã hội</a></li>
              <li><a href="#">Văn hóa</a></li>
              <li><a href="#">Thể thao</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Thông tin</h4>
            <ul>
              <li><a href="#">Điều khoản sử dụng</a></li>
              <li><a href="#">Chính sách bảo mật</a></li>
              <li><a href="#">Liên hệ</a></li>
              <li><a href="#">Sitemap</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Liên hệ</h4>
            <div className="contact-info">
              <p>📍 Việt Nam</p>
              <p>📞 (+84) 123 456 789</p>
              <p>✉️ info@baoxaviettien.vn</p>
              <p>🕒 24/7 cập nhật tin tức</p>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; 2024 Báo Xã Việt Tiến. Tất cả quyền được bảo lưu.</p>
          </div>
          <div className="tech-info">
            <p>Được xây dựng với ❤️ bằng React & Cloudflare | Cập nhật 24/7</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer